<template lang='pug'>
  div(v-resize='onResize' :id='editorId').diff
</template>

<script>
import _ from 'lodash';
import * as monaco from 'monaco-editor';
import Monaco from '../services/monaco.service';

export default {
  name: 'BionicMetricsMonacoDiffEditor',
  props: {
    mode: {
      type: String,
      default: 'javascript'
    },
    type: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'vs-dark'
    },
    guid: {
      type: String
    },
    gitName: {
      type: String
    },
    original: {
      type: String,
      required: true
    },
    value: {
      default() {
        return '';
      }
    }
  },
  async mounted() {
    this.editorId = `diff-${this.randomNumber(5)}`;
    this.uri = Monaco.getUri({dir: this.type, guid: this.guid, gitName: this.gitName});
    this.$nextTick(() => {
      this.setupEditor();
    });
  },
  beforeDestroy() {
    this.editor.dispose();
  },
  methods: {
    setupModels() {
      this.originalModel = monaco.editor.createModel(this.original, this.mode);
      this.monacoModel = monaco.editor.getModel(this.uri);
      if (this.monacoModel) {
        // Model exists, checking if monaco value is the same
        if (this.value !== this.monacoModel.getValue()) {
          // Not the same so update monaco value
          this.monacoModel.setValue(this.value);
        }
      } else {
        // Model didn't exist, create a new one
        this.monacoModel = monaco.editor.createModel(this.value, this.mode, this.uri);
      }
    },
    setupEditor() {
      this.setupModels();
      this.editor = monaco.editor.createDiffEditor(document.getElementById(this.editorId), {
        language: this.mode,
        theme: this.theme
      });
      this.editor.setModel({
        original: this.originalModel,
        modified: this.monacoModel
      });
      this.monacoModel.onDidChangeContent(_.debounce(this.valueChanged, 300, {leading: true}));
    },
    // eslint-disable-next-line
    onResize: _.debounce(function () {
      this.editor.layout();
    }, 250),
    set(value) {
      this.monacoModel.setValue(value);
    },
    valueChanged() {
      this.$emit('input', this.monacoModel.getValue());
    },
    randomNumber(digits) {
      // eslint-disable-next-line
      return Math.floor(Math.pow(10, digits - 1) + Math.random() * (Math.pow(10, digits) - Math.pow(10, digits - 1) - 1));
    }
  },
  mixins: [],
  data() {
    return {
      uri: null,
      initialSet: true,
      editorId: 'diff',
      editor: null,
      originalModel: null,
      monacoModel: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .diff {
    height: 100%;
  }
</style>
